<template>
  <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="less">
html,body{
  background: #121212;
  background-color: #121212!important;
}
</style>
